import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

// 任务方案-维度选择弹窗
export const getJqDim = (dmpId, params) => {
  return apiBaseUrl.get(`sptalentrv/mgr/dmp/${dmpId}/jq/dim`, params);
};

